// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object, string } from 'prop-types'
import Checkbox from './Checkbox'
import ErrorSimple from './ErrorSimple'

const CheckboxGroup = props => {
  const {
    checkBoxClasses,
    idRoot,
    input,
    meta,
    onChangeCustom,
    options,
  } = props

  return (
    <div>
      <div className={`checkbox-group ${checkBoxClasses}`}>
        {options.map((o, i) => (
          <Checkbox
            key={i}
            input={input}
            id={`${idRoot}-${o.value}`}
            index={i}
            onChangeCustom={onChangeCustom}
            {...o} />
        ))}
      </div>
      <ErrorSimple
        error={meta.error}
        idRoot={idRoot} />
    </div>
  )
}

CheckboxGroup.propTypes = {
  checkBoxClasses: string,
  idRoot: string.isRequired,
  input: object.isRequired,
  meta: object.isRequired,
  onChangeCustom: func,
  options: array.isRequired,
}

export default CheckboxGroup
